import * as React from 'react'
import type { SVGProps } from 'react'
const SvgGooglePlay = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m12.643 10.679 2.7-2.893L4.864 2.129C4.8 2.064 4.671 2.064 4.48 2l8.164 8.679zm3.857 4.178 3.793-2.057c.45-.257.707-.643.707-1.157s-.257-.964-.707-1.157L16.5 8.429l-3.021 3.214zM3.257 2.579c-.193.192-.257.45-.257.707V20c0 .257.064.514.257.771l8.486-9.128zm9.386 10.028-8.164 8.679c.128 0 .257-.065.385-.129L15.343 15.5z"
    />
  </svg>
)
export default SvgGooglePlay
